import { Component, OnInit } from '@angular/core';
import { RolesService } from '../../../core/services/roles/roles.service';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-settings-overview',
  templateUrl: './settings-overview.component.html',
  styleUrls: ['./settings-overview.component.scss'],
})
export class SettingsOverviewComponent implements OnInit
{
  tenantName: string = '';
  constructor(
    protected keycloakAngular: KeycloakService,
    public rolesService: RolesService,
  ) {

  }

  ngOnInit(){
    let key = 'tenant_id';
    this.tenantName = this.keycloakAngular.getKeycloakInstance()
      ? (this.keycloakAngular.getKeycloakInstance()?.idTokenParsed as any)[key]
      : '';

    console.log('Tenant name', this.tenantName);
  }

  public settingsOverviewBoxes = [
    {
      icon: 'icon-settings',
      label: 'rentModule.settingsOverviewComponent.boxes.general.label',
      description: 'rentModule.settingsOverviewComponent.boxes.general.description',
      path: 'settings/general',
      role: 'framework_settings_manage'
    },
    {
      icon: 'icon-company',
      label: 'rentModule.settingsOverviewComponent.boxes.company.label',
      description: 'rentModule.settingsOverviewComponent.boxes.company.description',
      path: 'company',
      role: 'framework_tenants_manage_own'
    },
    {
      icon: 'icon-branches',
      label: 'rentModule.settingsOverviewComponent.boxes.locations.label',
      description: 'rentModule.settingsOverviewComponent.boxes.locations.description',
      path: 'settings/locations',
      role: 'nexcore_location_view'
    },
    {
      icon: 'icon-person',
      label: 'rentModule.settingsOverviewComponent.boxes.users.label',
      description: 'rentModule.settingsOverviewComponent.boxes.users.description',
      path: 'settings/users',
      role: 'framework_users_manage'
    },
    {
      icon: 'icon-mobile-device',
      label: 'rentModule.settingsOverviewComponent.boxes.devices.label',
      description: 'rentModule.settingsOverviewComponent.boxes.devices.description',
      path: 'settings/mobileDevices',
      role: 'framework_mobileDevice_view'
    },
    {
      icon: 'icon-group',
      label: 'rentModule.settingsOverviewComponent.boxes.groups.label',
      description: 'rentModule.settingsOverviewComponent.boxes.groups.description',
      path: 'settings/groups',
      role: 'framework_groups_manage'
    },
    {
      icon: 'icon-invoice',
      label: 'rentModule.settingsOverviewComponent.boxes.billing.label',
      description: 'rentModule.settingsOverviewComponent.boxes.billing.description',
      path: 'settings/billing',
      role: 'framework_licence_view'
    },
    {
      icon: 'icon-documents',
      label: 'rentModule.settingsOverviewComponent.boxes.forms.label',
      description: 'rentModule.settingsOverviewComponent.boxes.forms.description',
      path: 'settings/forms',
      role: 'framework_forms_manage'
    },
    {
      icon: 'icon-templates',
      label: 'rentModule.settingsOverviewComponent.boxes.templates.label',
      description: 'rentModule.settingsOverviewComponent.boxes.templates.description',
      path: 'settings/templates',
      role: 'framework_templates_manage'
    },
    {
      icon: 'icon-api',
      label: 'rentModule.settingsOverviewComponent.boxes.developer.label',
      description: 'rentModule.settingsOverviewComponent.boxes.developer.description',
      path: 'settings/developer',
      role: 'framework_developer_view'
    },
    {
      icon: 'icon-tenant',
      label: 'rentModule.settingsOverviewComponent.boxes.tenants.label',
      description: 'rentModule.settingsOverviewComponent.boxes.tenants.description',
      path: 'settings/tenants',
      role: 'framework_tenants_manage'
    },
    {
      icon: 'icon-time',
      label: 'rentModule.settingsOverviewComponent.boxes.timeEntryCategories.label',
      description: 'rentModule.settingsOverviewComponent.boxes.timeEntryCategories.description',
      path: 'settings/timeEntryCategories',
      role: 'framework_timeEntryCategory_manage'
    },
    {
      icon: 'icon-check',
      label: 'Aufgaben',
      description: 'Einstellungen rund um Aufgaben.',
      path: 'settings/tasks',
      role: 'framework_tenants_manage'
    },
    {
      icon: 'icon-protocol-2',
      label: 'Vorgänge',
      description: 'Einstellungen rund um Vorgänge.',
      path: 'settings/issues',
      role: 'framework_tenants_manage'
    },
    {
      icon: 'icon-bookmark',
      label: 'Labels',
      description: 'Verwalten von Labels.',
      path: 'settings/labels',
      role: 'framework_labels_manage'
    },
    // #737: Support-Flaeche fuer Zustellprobleme. Bewusst NICHT "Benachrichtigungen" — das waere mit
    // den eigenen Benachrichtigungs-Einstellungen im Profil (#735) verwechselbar.
    {
      icon: 'icon-notification',
      label: 'rentModule.settingsOverviewComponent.boxes.notificationSupport.label',
      description: 'rentModule.settingsOverviewComponent.boxes.notificationSupport.description',
      path: 'settings/notifications',
      role: 'framework_notifications_support'
    },
    // #738: Announcement-Verwaltung. Fachlich ein reines Nexato-Feature — kein Mandant verschickt
    // Announcements, deshalb die Plattform-Rolle.
    {
      icon: 'icon-notification',
      label: 'rentModule.settingsOverviewComponent.boxes.announcements.label',
      description: 'rentModule.settingsOverviewComponent.boxes.announcements.description',
      path: 'settings/announcements',
      role: 'framework_nexato_employee'
    },
    // #746: Job-Verwaltung. Admin-Einsicht in Quartz-Jobs/-Trigger, tenantuebergreifend — deshalb
    // die Plattform-Rolle, analog zu Announcements und Notification-Diagnose.
    {
      icon: 'icon-time',
      label: 'rentModule.settingsOverviewComponent.boxes.jobAdmin.label',
      description: 'rentModule.settingsOverviewComponent.boxes.jobAdmin.description',
      path: 'settings/job-admin',
      role: 'framework_nexato_employee'
    }

  ];

  public getSettingsOverviewBoxes() {
    return this.settingsOverviewBoxes.filter(item => this.rolesService.hasRole(item.role));
  }


}
